import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FloatingAppBar from './FloatingAppBar'; 
import FloatingVerticalMenu from './FloatingVerticalMenu'; 
import ADashboard from './aDashboard/ADashboard'; 
import AssignTasks from './assignTasks/AssignTasks'; 
import ViewEmployees from './viewEmployees/ViewEmployees'; 
import ALeaveManagement from './aLeaveManagement/aLeaveManagement';

const AdminDashboard = () => {
  const location = useLocation();
  const { user } = location.state || {}; // Receive userDoc from navigation state

  // Get the current menu from session storage or fallback to 'dashboard'
  const [selectedMenu, setSelectedMenu] = useState('dashboard')

  useEffect(() => {
    // Save the selected menu to session storage whenever it changes
    sessionStorage.setItem('selectedMenu', selectedMenu);
  }, [selectedMenu]);

  const handleManageEmployeesClick = () => {
    setSelectedMenu('employees');
  };

  const handleAddTaskClick = () => {
    setSelectedMenu('tasks');
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case 'dashboard':
        return <ADashboard onManageEmployeesClick={handleManageEmployeesClick} onAddTaskClick={handleAddTaskClick} />;
      case 'tasks':
        return <AssignTasks user={user} />;
      case 'employees':
        return <ViewEmployees />;
      case 'leaveManagement': // New case for Leave Management
        return <ALeaveManagement />;
      default:
        return <ADashboard onManageEmployeesClick={handleManageEmployeesClick} onAddTaskClick={handleAddTaskClick} />;
    }
  };
  

  return (
    <div>
      <FloatingAppBar user={user} /> 
      <div style={{ display: 'flex', marginTop: '35px' }}>
        <FloatingVerticalMenu selectedMenu={selectedMenu} onMenuSelect={setSelectedMenu} />
        <div style={{ marginLeft: '100px', padding: '20px', flex: 1 }}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
